// extracted by mini-css-extract-plugin
export var alternate = "_n-h";
export var black = "_n-3";
export var blue = "_n-d";
export var blueLight = "_n-c";
export var brand = "_n-7";
export var error = "_n-9";
export var gray = "_n-6";
export var grayBlue = "_n-b";
export var iconWrapper = "_n-4";
export var indigo = "_n-e";
export var orange = "_n-g";
export var pink = "_n-f";
export var primary = "_n-0";
export var purple = "_n-8";
export var success = "_n-5";
export var warning = "_n-a";
export var white = "_n-1";
export var whiteSuccess = "_n-2";